// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Params_view__PCao0{
  display: flex;
  justify-content: center;
}

.Params_title__65cbg {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.Params_label__CwPvF {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.Params_input__no6Da,
.Params_input__no6Da .ant-select-selector {
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important;
  border-radius: 4px !important;
}

.Params_submit__zTpn9 {
  width: 250px;
  font-weight: 700;
  font-size: 13px;
}

/* Custom KPI-like Sidebar */

@keyframes Params_fadeInContent__\\+RV83 {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.Params_animatedContent__F1AYp {
  width: 100%;
  animation: Params_fadeInContent__\\+RV83 0.35s ease-out;
}

.Params_navWrapper__T2arB {
  width: 240px;
  min-width: 240px;
  position: sticky;
  top: 24px;
}

.Params_cardsContainer__H5N3b {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Params_card__iqlyz {
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  border-radius: 10px !important;
  border: 1px solid #f0f0f0 !important;
  transition: all 0.25s ease !important;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  padding: 12px 16px;
  background: #fff;
  color: #383838;
}

.Params_card__iqlyz:hover {
  border-color: #ffe0cc !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.Params_activeCard__DM9wE {
  background-color: #ff6b00 !important;
  color: #fff !important;
  border-color: #ff6b00 !important;
}

.Params_submitBtnTop__4WmAz {
  font-weight: 600;
  border-radius: 10px;
  height: 40px;
  width: 100%;
  margin-bottom: 12px;
  background-color: #ff6b00;
  border: none;
}

.Params_submitBtnTop__4WmAz:hover {
  background-color: #e66000 !important;
}

@media (max-width: 768px) {
  .Params_customTabs__ZMN0K .ant-tabs-nav {
    min-width: 100%;
    padding: 0 16px;
  }

  .Params_submitBtnTop__4WmAz {
    margin-right: 16px;
    padding: 0 12px;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/params/styles/Params.module.css"],"names":[],"mappings":"AACA;EACI,aAAa;EACb,uBAAuB;AAC3B;;AAEA;EACI,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAGF;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACI,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACnB;;AAEA,4BAA4B;;AAE5B;EACI;IACI,UAAU;IACV,0BAA0B;EAC9B;;EACA;IACI,UAAU;IACV,wBAAwB;EAC5B;AACJ;;AAEA;EACI,WAAW;EACX,sDAAuC;AAC3C;;AAEA;EACI,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACb;;AAEA;EACI,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACZ;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,oCAAoC;EACpC,qCAAqC;EACrC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAClB;;AAEA;EACI,gCAAgC;EAChC,qDAAqD;AACzD;;AAEA;EACI,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AACpC;;AAEA;EACI,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AAChB;;AACA;EACI,oCAAoC;AACxC;;AAMA;EACI;IACI,eAAe;IACf,eAAe;EACnB;;EACA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;EACnB;AACJ","sourcesContent":["\n.view{\n    display: flex;\n    justify-content: center;\n}\n\n.title {\n    color: var(--darkGray);\n    font-family: BebasNeue;\n    font-weight: 700;\n    font-size: 20px;\n  }\n  \n  .label {\n    font-weight: 500;\n    color: var(--darkGray);\n    font-size: 12px;\n  }\n  \n\n.input,\n.input :global(.ant-select-selector) {\n  background-color: #fbfbfb !important;\n  border-color: #d2d2d2 !important;\n  border-radius: 4px !important;\n}\n\n.submit {\n    width: 250px;\n    font-weight: 700;\n    font-size: 13px;\n}\n\n/* Custom KPI-like Sidebar */\n\n@keyframes fadeInContent {\n    from {\n        opacity: 0;\n        transform: translateY(8px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.animatedContent {\n    width: 100%;\n    animation: fadeInContent 0.35s ease-out;\n}\n\n.navWrapper {\n    width: 240px;\n    min-width: 240px;\n    position: sticky;\n    top: 24px;\n}\n\n.cardsContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.card {\n    font-size: 13px;\n    font-weight: 500;\n    text-align: left;\n    border-radius: 10px !important;\n    border: 1px solid #f0f0f0 !important;\n    transition: all 0.25s ease !important;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n    padding: 12px 16px;\n    background: #fff;\n    color: #383838;\n}\n\n.card:hover {\n    border-color: #ffe0cc !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;\n}\n\n.activeCard {\n    background-color: #ff6b00 !important;\n    color: #fff !important;\n    border-color: #ff6b00 !important;\n}\n\n.submitBtnTop {\n    font-weight: 600;\n    border-radius: 10px;\n    height: 40px;\n    width: 100%;\n    margin-bottom: 12px;\n    background-color: #ff6b00;\n    border: none;\n}\n.submitBtnTop:hover {\n    background-color: #e66000 !important;\n}\n\n\n\n\n\n@media (max-width: 768px) {\n    .customTabs :global(.ant-tabs-nav) {\n        min-width: 100%;\n        padding: 0 16px;\n    }\n    .submitBtnTop {\n        margin-right: 16px;\n        padding: 0 12px;\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `Params_view__PCao0`,
	"title": `Params_title__65cbg`,
	"label": `Params_label__CwPvF`,
	"input": `Params_input__no6Da`,
	"submit": `Params_submit__zTpn9`,
	"animatedContent": `Params_animatedContent__F1AYp`,
	"fadeInContent": `Params_fadeInContent__+RV83`,
	"navWrapper": `Params_navWrapper__T2arB`,
	"cardsContainer": `Params_cardsContainer__H5N3b`,
	"card": `Params_card__iqlyz`,
	"activeCard": `Params_activeCard__DM9wE`,
	"submitBtnTop": `Params_submitBtnTop__4WmAz`,
	"customTabs": `Params_customTabs__ZMN0K`
};
export default ___CSS_LOADER_EXPORT___;
